<div class="ds-accent"></div>

<div class="sol-page">
    <app-spinner
        [show]="spinnerVisible"
        [text]="spinnerTexto"
        [type]="'fullscreen'"
        [size]="'large'"
        [color]="'#B1476A'"
        [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>

    <ng-container *ngIf="flagLoaded">
        <!-- ============ Cabecera ============ -->
        <header class="sol-head">
            <div class="sol-head__title">
                <span class="sol-head__icono material-icons">{{ iconoTramite }}</span>
                <div>
                    <h1>{{ actividad?.nombre }}</h1>
                    <p *ngIf="modo === 'nueva'">Nueva solicitud médica</p>
                    <p *ngIf="modo === 'existente'">Solicitud Nº {{ solicitud?._nro }}</p>
                </div>
            </div>
            <span class="ds-chip" [ngClass]="chipEstado" *ngIf="modo === 'existente'">
                {{ estadoNombre }}
            </span>
        </header>

        <!-- ============ Pasos (modo nueva) ============ -->
        <ol class="sol-pasos" *ngIf="modo === 'nueva'">
            <li class="sol-paso" [class.sol-paso--active]="pasoNueva === 1"
                [class.sol-paso--done]="pasoNueva > 1">
                <span class="sol-paso__num">1</span>
                Datos del trámite
            </li>
            <li class="sol-paso" [class.sol-paso--active]="pasoNueva === 2">
                <span class="sol-paso__num">2</span>
                Confirmación
            </li>
        </ol>

        <div class="sol-grid">
            <!-- ============ Columna principal ============ -->
            <section class="sol-main">
                <!-- ---------- MODO NUEVA ---------- -->
                <ng-container *ngIf="modo === 'nueva'">
                    <!-- Paso 1: detalle + beneficiario -->
                    <div class="ds-card" *ngIf="pasoNueva === 1">
                        <div class="ds-section__head">
                            <span class="material-icons">description</span>
                            Descripción del trámite
                        </div>
                        <div class="ds-section__body">
                            <div class="sol-desc"
                                [class.sol-desc--collapsed]="descripcionEsLarga && !descripcionExpandida">
                                <p class="sol-texto" *ngIf="tieneTexto(actividad?.descripcion)">
                                    {{ actividad?.descripcion }}
                                </p>
                                <p class="sol-texto" *ngIf="tieneTexto(actividad?.detalle)">
                                    {{ actividad?.detalle }}
                                </p>
                            </div>

                            <button type="button" class="sol-ver-mas" *ngIf="descripcionEsLarga"
                                (click)="descripcionExpandida = !descripcionExpandida">
                                {{ descripcionExpandida ? 'Ver menos' : 'Ver más' }}
                                <span class="material-icons">
                                    {{ descripcionExpandida ? 'expand_less' : 'expand_more' }}
                                </span>
                            </button>

                            <ng-container *ngIf="tieneTexto(actividad?.requisitos)">
                                <h3 class="sol-subtitulo">Requerimientos</h3>
                                <p class="sol-texto">{{ actividad?.requisitos }}</p>
                            </ng-container>

                            <ng-container *ngIf="tieneTexto(actividad?.documentacionRequerida)">
                                <h3 class="sol-subtitulo">Documentación requerida</h3>
                                <p class="sol-texto">{{ actividad?.documentacionRequerida }}</p>
                            </ng-container>

                            <div class="ds-alert ds-alert--warning" *ngIf="tieneTexto(actividad?.importante)">
                                <span class="material-icons">priority_high</span>
                                <div><strong>Importante:</strong> {{ actividad?.importante }}</div>
                            </div>
                        </div>

                        <div class="ds-section__head">
                            <span class="material-icons">person</span>
                            Beneficiario
                        </div>
                        <div class="ds-section__body">
                            <div class="ds-field">
                                <label class="ds-field__label" for="beneficiario">
                                    ¿Para quién es la solicitud?
                                </label>
                                <div class="ds-field__control">
                                    <select id="beneficiario" class="ds-field__select"
                                        [formControl]="formSolicitud.get('beneficiario')"
                                        (change)="onBeneficiarioChange($event)">
                                        <option value="" disabled>Seleccione el beneficiario</option>
                                        <option *ngFor="let b of beneficiarios" [value]="b._id">
                                            {{ b.fullName }} - {{ b.parentesco }}
                                        </option>
                                    </select>
                                    <span class="ds-field__caret material-icons">expand_more</span>
                                </div>
                                <span class="ds-field__hint">
                                    El afiliado que inició sesión puede realizar la solicitud en nombre de un
                                    familiar a su cargo.
                                </span>
                            </div>
                        </div>

                        <div class="sol-actions sol-actions--sticky">
                            <button type="button" class="ds-pill ds-pill--primary"
                                [disabled]="formSolicitud.invalid" (click)="irAResumen()">
                                Continuar
                                <span class="material-icons">arrow_forward</span>
                            </button>
                        </div>
                    </div>

                    <!-- Paso 2: check answers -->
                    <div class="ds-card" *ngIf="pasoNueva === 2">
                        <div class="ds-section__head">
                            <span class="material-icons">fact_check</span>
                            Confirmá los datos antes de enviar
                        </div>
                        <div class="ds-section__body">
                            <div class="ds-summary ds-summary--grid">
                                <div class="ds-summary__row">
                                    <span class="ds-summary__key">Trámite</span>
                                    <span class="ds-summary__value">{{ actividad?.nombre }}</span>
                                </div>
                                <div class="ds-summary__row">
                                    <span class="ds-summary__key">Beneficiario</span>
                                    <span class="ds-summary__value">{{ beneficiarioLabel }}</span>
                                </div>
                                <div class="ds-summary__row">
                                    <span class="ds-summary__key">Titular</span>
                                    <span class="ds-summary__value">{{ usuario?.fullName }}</span>
                                </div>
                                <div class="ds-summary__row">
                                    <span class="ds-summary__key">Lugar de trámite</span>
                                    <span class="ds-summary__value">{{ nombrePais }}</span>
                                </div>
                                <div class="ds-summary__row" *ngIf="actividad?.documentosEstadosSolicitar?.length">
                                    <span class="ds-summary__key">Documentación</span>
                                    <span class="ds-summary__value">
                                        {{ actividad.documentosEstadosSolicitar.length }} documentos a presentar
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="sol-actions sol-actions--sticky">
                            <button type="button" class="ds-pill ds-pill--ghost" (click)="volverADatos()">
                                Volver
                            </button>
                            <button type="button" class="ds-pill ds-pill--primary"
                                [disabled]="flagProcesando" (click)="procesarSolicitudAutorizacion()">
                                <span class="material-icons">send</span>
                                Iniciar solicitud
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- ---------- MODO EXISTENTE ---------- -->
                <ng-container *ngIf="modo === 'existente'">
                    <div class="ds-confirmation" *ngIf="mostrarConfirmacion">
                        <span class="material-icons">check_circle</span>
                        <span class="ds-confirmation__title">Solicitud creada</span>
                        <span class="ds-confirmation__nro">Nº {{ solicitud?._nro }}</span>
                        <span class="ds-confirmation__text">Para que avance, subí la documentación.</span>
                    </div>

                    <div class="ds-alert ds-alert--success" *ngIf="flagEnRevision">
                        <span class="material-icons">check_circle</span>
                        <div>
                            <strong>Documentación en revisión.</strong>
                            Una vez aprobada recibirás un correo de confirmación.
                        </div>
                    </div>

                    <div class="ds-alert ds-alert--info" *ngIf="flagEnAuditoria">
                        <span class="material-icons">fact_check</span>
                        <div><strong>En auditoría médica.</strong> Tu documentación está siendo evaluada.</div>
                    </div>

                    <div class="ds-alert ds-alert--success" *ngIf="flagAprobado">
                        <span class="material-icons">verified</span>
                        <div><strong>Aprobado.</strong> ¡Felicitaciones! Tu trámite fue aprobado.</div>
                    </div>

                    <div class="ds-alert ds-alert--danger" *ngIf="flagRechazada">
                        <span class="material-icons">block</span>
                        <div>
                            <strong>Rechazado.</strong>
                            {{ solicitud?.lastState?.observaciones }}
                            Revisá tu correo (incluida la carpeta de spam) con el asunto
                            SIGNO MÉDICO - CAMBIO ESTADO SOLICITUD.
                        </div>
                    </div>

                    <div class="ds-card">
                        <div class="ds-tabbar">
                            <button type="button" class="ds-tab"
                                [class.ds-tab--active]="tabActiva === 'documentacion'"
                                (click)="tabActiva = 'documentacion'">
                                Documentación
                            </button>
                            <button type="button" class="ds-tab"
                                [class.ds-tab--active]="tabActiva === 'enviados'"
                                (click)="tabActiva = 'enviados'">
                                Documentos enviados ({{ files.length + imgs.length }})
                            </button>
                        </div>

                        <!-- Tab: documentación -->
                        <div class="ds-section__body" *ngIf="tabActiva === 'documentacion'">
                            <!-- Documentación requerida -->
                            <div class="sol-seccion" *ngIf="documentosEstadosSolicitar?.length">
                                <div class="sol-seccion__head">
                                    <span class="sol-seccion__titulo">Documentación requerida</span>
                                </div>

                                <div class="sol-docs">
                                    <label class="ds-dropzone ds-dropzone--sm"
                                        *ngFor="let doc of documentosEstadosSolicitar; let i = index"
                                        [class.ds-dropzone--done]="doc.entregado"
                                        [class.ds-dropzone--disabled]="doc.entregado || !activarCargaDocumentosOpcionales">
                                        <span class="material-icons">
                                            {{ doc.entregado ? 'check_circle' : 'upload_file' }}
                                        </span>
                                        <span>
                                            <strong>
                                                {{ doc.entregado ? doc.documento.nombre : 'Adjuntar ' + doc.documento.nombre }}
                                            </strong>
                                        </span>
                                        <span class="sol-drop__hint" *ngIf="doc.documento.descripcion">
                                            {{ doc.documento.descripcion }}
                                        </span>
                                        <span *ngIf="!doc.entregado">
                                            PDF, JPG, PNG o HEIC · hasta {{ maxArchivoMb }} MB por archivo
                                        </span>
                                        <span class="ds-chip ds-chip--aprobado" *ngIf="doc.entregado">
                                            Entregado
                                        </span>
                                        <input type="file" [accept]="acceptArchivos"
                                            [disabled]="doc.entregado || !activarCargaDocumentosOpcionales"
                                            (change)="onFileSelectedDocumento($event, doc)" />
                                    </label>
                                </div>
                            </div>

                            <div class="ds-alert ds-alert--info" *ngIf="!documentosEstadosSolicitar?.length">
                                <span class="material-icons">info</span>
                                <div>
                                    Este trámite no requiere documentación fija. Podés adjuntar los respaldos
                                    que consideres necesarios.
                                </div>
                            </div>

                            <!-- Documentación adicional -->
                            <div class="sol-seccion" *ngIf="activarCargaExtra">
                                <div class="sol-seccion__head">
                                    <span class="sol-seccion__titulo">Documentación adicional</span>
                                    <span class="sol-seccion__nota">Opcional</span>
                                </div>

                                <label class="ds-dropzone ds-dropzone--sm">
                                    <span class="material-icons">upload_file</span>
                                    <span><strong>Adjuntar documentación adicional</strong></span>
                                    <span>PDF, JPG, PNG o HEIC · hasta {{ maxArchivoMb }} MB por archivo</span>
                                    <input type="file" [accept]="acceptArchivos" (change)="onFileSelected($event)" />
                                </label>

                                <div class="sol-temp" *ngIf="documentosTemporales.length > 0">
                                    <h4 class="sol-temp__title">Documentos cargados (sin enviar)</h4>
                                    <ul class="sol-temp__lista">
                                        <li class="sol-temp__item"
                                            *ngFor="let doc of documentosTemporales; trackBy: trackByDocumento">
                                            <img class="sol-temp__preview" *ngIf="doc.preview" [src]="doc.preview" alt="" />
                                            <span class="material-icons sol-temp__icon" *ngIf="!doc.preview">description</span>
                                            <div class="sol-temp__info">
                                                <span class="sol-temp__nombre">{{ doc.nombre }}</span>
                                                <span class="sol-temp__fecha">
                                                    {{ doc.fecha | date: "dd/MM/yyyy HH:mm" }}
                                                </span>
                                            </div>
                                            <button type="button" class="sol-temp__del"
                                                (click)="eliminarDocumentoTemp(doc.tempId)"
                                                aria-label="Eliminar documento">
                                                <span class="material-icons">delete</span>
                                            </button>
                                        </li>
                                    </ul>
                                    <div class="ds-alert ds-alert--info">
                                        <span class="material-icons">info</span>
                                        <div>Se enviarán cuando presiones <strong>Finalizar carga</strong>.</div>
                                    </div>
                                </div>
                            </div>

                            <div class="sol-actions sol-actions--wrap" *ngIf="activarCargaExtra">
                                <button type="button" class="ds-pill ds-pill--primary"
                                    [disabled]="flagProcesandoFinalizar || (!puedeEnviarARevision && documentosTemporales.length === 0)"
                                    (click)="finalizarCargaDocumentosSolicitud($event)">
                                    <span class="material-icons">
                                        {{ puedeEnviarARevision ? 'check_circle' : 'upload_file' }}
                                    </span>
                                    {{ textoFinalizar }}
                                </button>
                            </div>
                        </div>

                        <!-- Tab: documentos enviados -->
                        <div class="ds-section__body" *ngIf="tabActiva === 'enviados'">
                            <ng-container *ngIf="imgs.length > 0; else sinFotos">
                                <h3 class="sol-subtitulo">Fotos</h3>
                                <app-ofertas-gallery [imagenes]="imgs" [id_usuario]="usuario?._id"></app-ofertas-gallery>
                            </ng-container>
                            <ng-template #sinFotos>
                                <div class="ds-alert ds-alert--info">
                                    <span class="material-icons">photo_library</span>
                                    <div>Sin fotos cargadas.</div>
                                </div>
                            </ng-template>

                            <ng-container *ngIf="files.length > 0">
                                <h3 class="sol-subtitulo">Archivos</h3>
                                <app-ofertas-files [files]="files" [usuario]="usuario"></app-ofertas-files>
                            </ng-container>
                        </div>
                    </div>

                    <div class="ds-card">
                        <div class="ds-section__head">
                            <span class="material-icons">history</span>
                            Historial de estados
                        </div>
                        <div class="ds-section__body">
                            <div class="ds-timeline" *ngIf="historial.length > 0; else sinHistorial">
                                <div class="ds-timeline__item" *ngFor="let estado of historial; let first = first"
                                    [class.ds-timeline__item--current]="first">
                                    <span class="ds-timeline__dot"></span>
                                    <span class="ds-timeline__date">{{ estado.date | date: "dd/MM/yyyy HH:mm" }}</span>
                                    <span class="ds-timeline__title">{{ getNombreEstado(estado.numberState) }}</span>
                                    <span class="ds-timeline__text" *ngIf="estado.observaciones">
                                        {{ estado.observaciones }}
                                    </span>
                                </div>
                            </div>
                            <ng-template #sinHistorial>
                                <div class="ds-alert ds-alert--info">
                                    <span class="material-icons">info</span>
                                    <div>Sin historial de estados disponible.</div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
            </section>

            <!-- ============ Aside ============ -->
            <aside class="sol-aside">
                <div class="ds-card" *ngIf="modo === 'existente'">
                    <div class="ds-section__head">
                        <span class="material-icons">timeline</span>
                        Estado de la solicitud
                    </div>
                    <div class="ds-section__body">
                        <app-stepper [stepperSet]="estadoParaStepper" [vertical]="true" [mostrarRecupero]="esTramiteRecupero"></app-stepper>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">info</span>
                        Información
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-summary">
                            <div class="ds-summary__row">
                                <span class="ds-summary__key">Lugar de trámite</span>
                                <span class="ds-summary__value">{{ nombrePais }}</span>
                            </div>
                            <div class="ds-summary__row" *ngIf="sede">
                                <span class="ds-summary__key">Sede</span>
                                <span class="ds-summary__value">{{ sede.nombre }}</span>
                            </div>
                            <div class="ds-summary__row" *ngIf="usuario">
                                <span class="ds-summary__key">Titular</span>
                                <span class="ds-summary__value">{{ usuario.fullName }}</span>
                            </div>
                            <div class="ds-summary__row" *ngIf="beneficiario">
                                <span class="ds-summary__key">Beneficiario</span>
                                <span class="ds-summary__value">
                                    {{ beneficiario?.adicional?.fullName || usuario?.fullName }}
                                    ({{ beneficiario?.parentesco || 'Titular' }})
                                </span>
                            </div>
                            <div class="ds-summary__row" *ngIf="actividad?.createdAt">
                                <span class="ds-summary__key">Publicado</span>
                                <span class="ds-summary__value">{{ actividad.createdAt | date: "dd/MM/yy" }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    </ng-container>
</div>
